import { render, staticRenderFns } from "./AttendancesPage.vue?vue&type=template&id=32f5fb32&scoped=true"
import script from "./AttendancesPage.vue?vue&type=script&lang=js"
export * from "./AttendancesPage.vue?vue&type=script&lang=js"
import style0 from "./AttendancesPage.vue?vue&type=style&index=0&id=32f5fb32&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f5fb32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32f5fb32')) {
      api.createRecord('32f5fb32', component.options)
    } else {
      api.reload('32f5fb32', component.options)
    }
    module.hot.accept("./AttendancesPage.vue?vue&type=template&id=32f5fb32&scoped=true", function () {
      api.rerender('32f5fb32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/attendances/attendances/AttendancesPage.vue"
export default component.exports